import ProductAskQuestionView from './views/product-ask-question.js';

export default class ProductAskQuestionApp {
	constructor({ placeholder, customer }) {
		this.view = null;
		this.btns = document.querySelectorAll('.js-ask-question');

		if ( this.btns.length ) {
			this.placeholder = placeholder;
			this.customer = customer;
			this.initEventHandlers();
		}
	}

	initView( event ) {
		const element = event.target;

		element.classList.add('progress');

		this.view = new ProductAskQuestionView({
			el: this.placeholder,
			customer: this.customer,
			modal_selector: '.product-ask-question-app',
			navigation: {
				image: window.ProductInfo.Image,
				caption: window.ProductInfo.Name
			}
		});

		this.view.once_rendered = () => {
			this.view.init_modal();
			this.view.init_popup_events();
			this.view.open();
			element.classList.remove('progress');
		};
	}

	initEventHandlers() {
		this.btns.forEach(button => {
			button.addEventListener('click', this.initView.bind(this));
		});
	}
}
